var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddratingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 5.0625C14.9038 5.0625 5.0625 14.9038 5.0625 27C5.0625 39.0962 14.9038 48.9375 27 48.9375C39.0962 48.9375 48.9375 39.0962 48.9375 27C48.9375 14.9038 39.0962 5.0625 27 5.0625ZM35.4375 28.6875H28.6875V35.4375C28.6875 35.8851 28.5097 36.3143 28.1932 36.6307C27.8768 36.9472 27.4476 37.125 27 37.125C26.5524 37.125 26.1232 36.9472 25.8068 36.6307C25.4903 36.3143 25.3125 35.8851 25.3125 35.4375V28.6875H18.5625C18.1149 28.6875 17.6857 28.5097 17.3693 28.1932C17.0528 27.8768 16.875 27.4476 16.875 27C16.875 26.5524 17.0528 26.1232 17.3693 25.8068C17.6857 25.4903 18.1149 25.3125 18.5625 25.3125H25.3125V18.5625C25.3125 18.1149 25.4903 17.6857 25.8068 17.3693C26.1232 17.0528 26.5524 16.875 27 16.875C27.4476 16.875 27.8768 17.0528 28.1932 17.3693C28.5097 17.6857 28.6875 18.1149 28.6875 18.5625V25.3125H35.4375C35.8851 25.3125 36.3143 25.4903 36.6307 25.8068C36.9472 26.1232 37.125 26.5524 37.125 27C37.125 27.4476 36.9472 27.8768 36.6307 28.1932C36.3143 28.5097 35.8851 28.6875 35.4375 28.6875Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddratingIcon);
export default __webpack_public_path__ + "static/media/addrating_icon.c9117917901387edfb633999bcdedbb1.svg";
export { ForwardRef as ReactComponent };